import React, { useState } from 'react';
import { User, CreditCard, LogOut } from 'lucide-react';

interface UserMenuProps {
  displayName?: string | null;
  specialization?: string | null;
  /** Cacheable avatar URL (from profile.avatar_url); when set, shown instead of initials */
  profilePhotoUrl?: string | null;
  onProfileClick: () => void;
  onBillingClick?: () => void;
  onLogout: () => void;
}

export const UserMenu: React.FC<UserMenuProps> = ({
  displayName,
  specialization,
  profilePhotoUrl,
  onProfileClick,
  onBillingClick,
  onLogout,
}) => {
  const [open, setOpen] = useState(false);
  const name = displayName && displayName.trim().length > 0 ? displayName : 'Doctor';
  const initials = name
    .split(' ')
    .filter((part) => part.trim().length > 0)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

  const toggle = () => setOpen((prev) => !prev);

  const handleProfile = () => {
    onProfileClick();
    setOpen(false);
  };

  const handleBilling = () => {
    onBillingClick?.();
    setOpen(false);
  };

  const handleLogout = () => {
    onLogout();
    setOpen(false);
  };

  return (
    <div className="user-menu">
      <button type="button" className="user-menu-chip" onClick={toggle}>
        <div className="user-menu-avatar">
          {profilePhotoUrl ? (
            <img src={profilePhotoUrl} alt="" className="user-menu-avatar-img" />
          ) : (
            <span>{initials}</span>
          )}
        </div>
        <div className="user-menu-text">
          <span className="user-menu-name">{name}</span>
          {specialization && (
            <span className="user-menu-specialization">{specialization}</span>
          )}
        </div>
        <span className="user-menu-caret">▾</span>
      </button>
      {open && (
        <div className="user-menu-dropdown">
          <button type="button" className="user-menu-item" onClick={handleProfile}>
            <span className="user-menu-item-icon">
              <User size={20} strokeWidth={2} />
            </span>
            <span>Your profile</span>
          </button>
          <button type="button" className="user-menu-item" onClick={handleBilling}>
            <span className="user-menu-item-icon">
              <CreditCard size={20} strokeWidth={2} />
            </span>
            <span>Wallet</span>
          </button>
          <button type="button" className="user-menu-item" onClick={handleLogout}>
            <span className="user-menu-item-icon">
              <LogOut size={20} strokeWidth={2} />
            </span>
            <span>Sign out</span>
          </button>
        </div>
      )}
    </div>
  );
};

